
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import EnrollmentChargeContent from "./components/EnrollmentChargeContent.vue";

export default defineComponent({
  name: "EnrollmentChargePage",
  components: {
    BreadCrumb,
    EnrollmentChargeContent,
  },
});
